import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";
import { Mutation, MutationFn } from "react-apollo";
import { ObservatoryBundleFields } from "./components/Form";
import { ObservatoryBundleForm } from "./components/ObservatoryBundleForm";
import {
  createObservatoryBundleMutation,
  CreateObservatoryBundleResult,
  CreateObservatoryBundleVariables,
} from "./queries";
import { RouteComponentProps } from "react-router";

const TOAST_DURATION = 5000;

type CreateObservatoryBundleMutationFn = MutationFn<
  CreateObservatoryBundleResult,
  CreateObservatoryBundleVariables
>;

export const NewObservatoryBundle = (props: RouteComponentProps) => {
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const toast = useToast({ duration: TOAST_DURATION, isClosable: true });

  const handleFormSubmit =
    (mutation: CreateObservatoryBundleMutationFn) =>
    async (data: ObservatoryBundleFields) => {
      try {
        setIsFormSubmitting(true);
        const result = await mutation({
          variables: {
            observatoryBundle: {
              name: data.name,
              description: data.description,
              isActive: data.isActive,
              roles: data.observatoryBundlesRole ? ["ObservatoryBundles"] : [],
              marketArrayReportId: data.marketArrayReport?.value,
              observatoryReportId: data.observatoryReport?.value,
              insightsReportId: data.insightsReport?.value,
              drilldownId: data.drilldown?.value,
            },
          },
        });

        const createObservatoryBundleResult =
          result?.data?.createObservatoryBundle;
        const success = createObservatoryBundleResult?.success;
        const message = createObservatoryBundleResult?.message;

        if (!success) {
          toast({
            title: "Error",
            description: message,
            status: "error",
          });
          return;
        }

        toast({
          title: "Success",
          description: message,
          status: "success",
        });

        props.history.push(
          `/observatory-bundles/${createObservatoryBundleResult?.observatoryBundle.id}/edit`
        );
      } catch (error) {
        console.error(error);
        toast({
          title: "Error",
          description: "An unknown error occurred.",
          status: "error",
        });
      }
    };

  return (
    <Mutation<CreateObservatoryBundleResult, CreateObservatoryBundleVariables>
      mutation={createObservatoryBundleMutation}
    >
      {(mutation: CreateObservatoryBundleMutationFn) => (
        <ObservatoryBundleForm
          title="New Observatory Bundle"
          onSubmit={handleFormSubmit(mutation)}
          isFormSubmitting={isFormSubmitting}
          buttonText="Create"
          buttonLoadingText="Creating..."
        />
      )}
    </Mutation>
  );
};
